import React from "react";
import Nav from "_shared/Nav/nav";

import "./dash-grid.scss";

export const DetailsContainer = ({ children }) => {
  return <section className="details-container"> {children} </section>;
};

export const MainContainer = ({ children }) => {
  return <section className="main-container"> {children} </section>;
};

export const RightContainer = ({ children }) => {
  return <section className="right-container">{children}</section>;
};

export const MiddleContainer = ({ children }) => {
  return <section className="middle-container">{children}</section>;
};

export const TopContainer = ({ children }) => {
  return <section className="top-container">{children}</section>;
};

const DashGrid = ({ children }) => {
  return <section className="dashbaord-grid-container">{children}</section>;
};

export const DashGridL1 = ({ Top, Middle, Main }) => {
  return (
    <section className="dashboard-grid-container">
      <Nav />
      <TopContainer>
        <Top />
      </TopContainer>
      <MiddleContainer>
        <Middle />
      </MiddleContainer>
      <MainContainer>
        <Main />
      </MainContainer>
    </section>
  );
};

export const DashGridL2 = ({ Top, Main }) => {
  return (
    <section className="dashboard-grid-container">
      <Nav />
      <TopContainer>
        <Top />
      </TopContainer>
      <DetailsContainer>
        <Main />
      </DetailsContainer>
    </section>
  );
};


export default DashGrid;
